// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="13px"]::before {
  content: "13";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="15px"]::before {
  content: "15";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="17px"]::before {
  content: "17";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
  content: "36";
  font-size: 14px !important; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before {
  content: "12"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="13px"]::before {
  content: "13"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before {
  content: "14"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="15px"]::before {
  content: "15"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before {
  content: "16"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="17px"]::before {
  content: "17"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before {
  content: "18"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before {
  content: "20"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before {
  content: "24"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before {
  content: "28"; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before {
  content: "36"; }

/* Set default font-family */
.app .ql-editor {
  font-family: "Ubuntu"; }

/* Set dropdown font-families */
.ql-picker.ql-font .ql-picker-label[data-value="arial"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="arial"]::before {
  font-family: Arial, Helvetica, sans-serif;
  content: "Arial"; }

.ql-picker.ql-font .ql-picker-label[data-value="georgia"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="georgia"]::before {
  font-family: "georgia";
  content: "Georgia"; }

.ql-picker.ql-font .ql-picker-label[data-value="nunito"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="nunito"]::before {
  font-family: "nunito", cursive;
  content: "Nunito"; }

.ql-picker.ql-font .ql-picker-label[data-value="calibri"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="calibri"]::before {
  font-family: "calibri";
  content: "Calibri"; }

.ql-picker.ql-font .ql-picker-label[data-value="roboto"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="roboto"]::before {
  font-family: "roboto";
  content: "Roboto"; }

.ql-picker.ql-font .ql-picker-label[data-value="lucida-console"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="lucida-console"]::before {
  font-family: "Lucida Console", "Courier New", monospace;
  content: "Lucida Console";
  width: 80px;
  text-overflow: clip;
  overflow: hidden;
  white-space: nowrap; }

.ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before,
.ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before {
  font-family: "Times New Roman", Times, serif;
  content: "Times New Roman";
  width: 80px;
  text-overflow: clip;
  overflow: hidden;
  white-space: nowrap; }

.ql-snow .ql-picker.ql-size {
  min-width: 60px;
  width: auto; }

/* Set content font-families */
.ql-font-roboto {
  font-family: "roboto"; }

.ql-font-calibri {
  font-family: "calibri"; }

.ql-font-arial {
  font-family: Arial, Helvetica, sans-serif; }

.ql-font-georgia {
  font-family: "georgia"; }

.ql-font-nunito {
  font-family: "nunito", cursive; }

.ql-font-lucida-console {
  font-family: "Lucida Console", "Courier New", monospace; }

.ql-font-times-new-roman {
  font-family: "Times New Roman", Times, serif; }
`, "",{"version":3,"sources":["webpack://./src/Components/QuillTextEditor/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAG5B;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf,4BAAA;AACA;EACE,qBAAqB,EAAA;;AAGvB,+BAAA;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB,EAAA;;AAElB;;EAEE,sBAAsB;EACtB,kBAAkB,EAAA;;AAEpB;;EAEE,8BAA8B;EAC9B,iBAAiB,EAAA;;AAEnB;;EAEE,sBAAsB;EACtB,kBAAkB,EAAA;;AAEpB;;EAEE,qBAAqB;EACrB,iBAAiB,EAAA;;AAEnB;;EAEE,uDAAuD;EACvD,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAA;;AAErB;;EAEE,4CAA4C;EAC5C,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,WAAW,EAAA;;AAGb,8BAAA;AACA;EACE,qBAAqB,EAAA;;AAEvB;EACE,sBAAsB,EAAA;;AAExB;EACE,yCAAyC,EAAA;;AAE3C;EACE,sBAAsB,EAAA;;AAExB;EACE,8BAA8B,EAAA;;AAEhC;EACE,uDAAuD,EAAA;;AAEzD;EACE,4CAA4C,EAAA","sourcesContent":[".ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"12px\"]::before {\n  content: \"12\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"13px\"]::before {\n  content: \"13\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"14px\"]::before {\n  content: \"14\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"15px\"]::before {\n  content: \"15\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"16px\"]::before {\n  content: \"16\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"17px\"]::before {\n  content: \"17\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before {\n  content: \"18\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"20px\"]::before {\n  content: \"20\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"24px\"]::before {\n  content: \"24\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"28px\"]::before {\n  content: \"28\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"32px\"]::before {\n  content: \"32\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"36px\"]::before {\n  content: \"36\";\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"12px\"]::before {\n  content: \"12\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"13px\"]::before {\n  content: \"13\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"14px\"]::before {\n  content: \"14\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"15px\"]::before {\n  content: \"15\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"16px\"]::before {\n  content: \"16\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"17px\"]::before {\n  content: \"17\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"18px\"]::before {\n  content: \"18\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"20px\"]::before {\n  content: \"20\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"24px\"]::before {\n  content: \"24\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"28px\"]::before {\n  content: \"28\";\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"36px\"]::before {\n  content: \"36\";\n}\n\n/* Set default font-family */\n.app .ql-editor {\n  font-family: \"Ubuntu\";\n}\n\n/* Set dropdown font-families */\n\n.ql-picker.ql-font .ql-picker-label[data-value=\"arial\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"arial\"]::before {\n  font-family: Arial, Helvetica, sans-serif;\n  content: \"Arial\";\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"georgia\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"georgia\"]::before {\n  font-family: \"georgia\";\n  content: \"Georgia\";\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"nunito\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"nunito\"]::before {\n  font-family: \"nunito\", cursive;\n  content: \"Nunito\";\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"calibri\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"calibri\"]::before {\n  font-family: \"calibri\";\n  content: \"Calibri\";\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"roboto\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"roboto\"]::before {\n  font-family: \"roboto\";\n  content: \"Roboto\";\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"lucida-console\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"lucida-console\"]::before {\n  font-family: \"Lucida Console\", \"Courier New\", monospace;\n  content: \"Lucida Console\";\n  width: 80px;\n  text-overflow: clip;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.ql-picker.ql-font .ql-picker-label[data-value=\"times-new-roman\"]::before,\n.ql-picker.ql-font .ql-picker-item[data-value=\"times-new-roman\"]::before {\n  font-family: \"Times New Roman\", Times, serif;\n  content: \"Times New Roman\";\n  width: 80px;\n  text-overflow: clip;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.ql-snow .ql-picker.ql-size {\n  min-width: 60px;\n  width: auto;\n}\n\n/* Set content font-families */\n.ql-font-roboto {\n  font-family: \"roboto\";\n}\n.ql-font-calibri {\n  font-family: \"calibri\";\n}\n.ql-font-arial {\n  font-family: Arial, Helvetica, sans-serif;\n}\n.ql-font-georgia {\n  font-family: \"georgia\";\n}\n.ql-font-nunito {\n  font-family: \"nunito\", cursive;\n}\n.ql-font-lucida-console {\n  font-family: \"Lucida Console\", \"Courier New\", monospace;\n}\n.ql-font-times-new-roman {\n  font-family: \"Times New Roman\", Times, serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
